import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

// ── All content pages — add new entries here as more pages are built ──────────
const PILLARS = [
  {
    id: 'p1',
    label: 'Pillar 1',
    title: 'CUET Coaching & Preparation',
    pages: [
      {
        to: '/cuet-coaching',
        title: 'CUET Coaching',
        subtitle: 'Best CUET Online Coaching by BESST',
        desc: 'Everything you need to know about structured CUET coaching — live classes, mock tests, mentorship, and more.',
        icon: '🎓',
        type: 'Pillar',
      },
      {
        to: '/best-cuet-coaching-in-assam',
        title: 'Best CUET Coaching in Assam',
        subtitle: 'Expert Online Coaching for Assam Students',
        desc: 'BESST brings dedicated CUET coaching to every district in Assam — no relocation, no commute.',
        icon: '📍',
        type: 'Guide',
      },
      {
        to: '/online-cuet-coaching',
        title: 'Online CUET Coaching',
        subtitle: 'Live CUET Classes from Anywhere',
        desc: 'Learn why online coaching is now the preferred format — flexibility, expert faculty, and full mock access.',
        icon: '💻',
        type: 'Guide',
      },
      {
        to: '/cuet-preparation-strategy',
        title: 'CUET Preparation Strategy',
        subtitle: 'Complete Guide to Crack CUET',
        desc: 'A step-by-step strategy covering syllabus analysis, NCERT fundamentals, mock tests, and revision.',
        icon: '🎯',
        type: 'Guide',
      },
      {
        to: '/how-to-crack-cuet',
        title: 'How to Crack CUET',
        subtitle: '10 Expert Tips to Score High',
        desc: '10 proven tips, a 60-day roadmap, common mistakes to avoid, and expert exam-day advice.',
        icon: '🏆',
        type: 'Guide',
      },
      {
        to: '/cuet-study-plan',
        title: 'CUET Study Plan',
        subtitle: '30-Day Preparation Strategy',
        desc: 'A practical 30-day plan with a daily timetable, weekly checklists, and subject-wise guidance.',
        icon: '🗓️',
        type: 'Guide',
      },
    ],
  },
  // ── Add future pillars below in the same format ───────────────────────────
  // {
  //   id: 'p2',
  //   label: 'Pillar 2',
  //   title: 'CUET Mock Tests & Practice',
  //   pages: [ ... ]
  // },
];

const TYPE_STYLE = {
  Pillar: { bg: 'rgba(212,175,55,0.15)', color: '#d4af37', border: 'rgba(212,175,55,0.35)' },
  Guide: { bg: 'rgba(124,58,237,0.12)', color: '#a78bfa', border: 'rgba(124,58,237,0.3)' },
};

const CSS = `
  .hub-page { background:linear-gradient(160deg,#0c0420 0%,#140831 50%,#0c0420 100%); min-height:100vh; color:#e8deff; font-family:'Inter','Segoe UI',system-ui,sans-serif; }

  /* Hero */
  .hub-hero { max-width:800px; margin:0 auto; padding:4rem 1.5rem 3rem; text-align:center; }
  .hub-eyebrow { display:inline-block; background:rgba(212,175,55,.12); color:#d4af37; border:1px solid rgba(212,175,55,.3); border-radius:20px; padding:.35rem 1rem; font-size:.75rem; font-weight:700; letter-spacing:.1em; text-transform:uppercase; margin-bottom:1.25rem; }
  .hub-h1 { font-size:clamp(2rem,5vw,3rem); font-weight:800; line-height:1.15; margin:0 0 1rem; color:#f0e6ff; }
  .hub-h1 em { font-style:normal; background:linear-gradient(90deg,#d4af37,#f59e0b); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
  .hub-sub { font-size:1.05rem; line-height:1.8; color:#c4b5fd; max-width:600px; margin:0 auto 2rem; }
  .hub-cta { display:flex; gap:1rem; justify-content:center; flex-wrap:wrap; }
  .btn-gold { background:linear-gradient(135deg,#d4af37,#f59e0b); color:#0c0420; font-weight:700; padding:.8rem 1.75rem; border-radius:10px; text-decoration:none; font-size:.95rem; transition:transform .2s,box-shadow .2s; }
  .btn-gold:hover { transform:translateY(-2px); box-shadow:0 8px 24px rgba(212,175,55,.35); }
  .btn-outline { background:transparent; color:#e8deff; font-weight:600; padding:.8rem 1.75rem; border-radius:10px; border:1.5px solid rgba(232,222,255,.25); text-decoration:none; font-size:.95rem; transition:border-color .2s; }
  .btn-outline:hover { border-color:#a78bfa; }

  /* Pillar section */
  .hub-body { max-width:1100px; margin:0 auto; padding:0 1.5rem 5rem; }
  .hub-pillar { margin-bottom:4rem; }
  .hub-pillar-header { display:flex; align-items:center; gap:12px; margin-bottom:1.5rem; padding-bottom:.75rem; border-bottom:1px solid rgba(255,255,255,.07); }
  .hub-pillar-badge { background:rgba(212,175,55,.1); color:#d4af37; border:1px solid rgba(212,175,55,.25); border-radius:8px; padding:.3rem .7rem; font-size:.72rem; font-weight:700; letter-spacing:.08em; text-transform:uppercase; flex-shrink:0; }
  .hub-pillar-title { font-size:1.15rem; font-weight:700; color:#f0e6ff; }

  /* Cards grid */
  .hub-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:1rem; }
  @media(max-width:900px) { .hub-grid { grid-template-columns:repeat(2,1fr); } }
  @media(max-width:560px) { .hub-grid { grid-template-columns:1fr; } }

  /* Card */
  .hub-card { position:relative; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); border-radius:14px; padding:1.4rem; display:flex; flex-direction:column; gap:.65rem; text-decoration:none; transition:border-color .2s,background .2s,transform .2s; }
  .hub-card:hover { border-color:rgba(212,175,55,.35); background:rgba(255,255,255,.07); transform:translateY(-2px); }
  .hub-card-top { display:flex; align-items:flex-start; justify-content:space-between; gap:.5rem; }
  .hub-card-icon { font-size:1.6rem; line-height:1; }
  .hub-card-type { font-size:.68rem; font-weight:700; letter-spacing:.07em; text-transform:uppercase; padding:.25rem .6rem; border-radius:10px; border:1px solid; flex-shrink:0; }
  .hub-card-title { font-size:1rem; font-weight:700; color:#f0e6ff; line-height:1.3; }
  .hub-card-subtitle { font-size:.8rem; color:#d4af37; font-weight:500; }
  .hub-card-desc { font-size:.85rem; line-height:1.65; color:#9ca3af; flex:1; }
  .hub-card-arrow { font-size:.85rem; color:#7c6b9e; margin-top:auto; display:flex; align-items:center; gap:.35rem; transition:color .2s; }
  .hub-card:hover .hub-card-arrow { color:#d4af37; }

  /* Pillar card (first card) gets a gold accent left border */
  .hub-card.is-pillar { border-left:3px solid rgba(212,175,55,.5); }

  /* Stats strip */
  .hub-stats { display:grid; grid-template-columns:repeat(4,1fr); gap:1rem; margin:0 auto 3.5rem; max-width:1100px; padding:0 1.5rem; }
  @media(max-width:640px) { .hub-stats { grid-template-columns:repeat(2,1fr); } }
  .hub-stat { background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.07); border-radius:12px; padding:1.1rem; text-align:center; }
  .hub-stat-val { font-size:1.6rem; font-weight:800; color:#d4af37; }
  .hub-stat-lbl { font-size:.75rem; color:#9ca3af; margin-top:2px; }
`;

const CuetHubPage = () => {
  const totalPages = PILLARS.reduce((s, p) => s + p.pages.length, 0);

  return (
    <>
      <Helmet>
        <title>CUET Preparation Resources | Complete Guide by BESST</title>
        <meta name="description" content="Browse BESST's complete library of CUET preparation guides — coaching, study plans, mock tests, strategy, and more. Everything in one place." />
        <link rel="canonical" href="https://besst.in/cuet-resources" />
      </Helmet>

      <div className="hub-page pt-32">
        <style>{CSS}</style>

        {/* Hero */}
        <div className="hub-hero">
          <div className="hub-eyebrow">CUET Preparation Hub</div>
          <h1 className="hub-h1">
            Everything You Need to<br /><em>Crack CUET</em> — In One Place
          </h1>
          <p className="hub-sub">
            Expert guides, preparation strategies, study plans, and coaching resources — all built specifically for CUET aspirants.
          </p>
          <div className="hub-cta">
            <Link to="/subscriptions" className="btn-gold">Start Coaching →</Link>
            <Link to="/cuet-mock-test" className="btn-outline">Try a Free Mock Test</Link>
          </div>
        </div>

        {/* Stats */}
        <div className="hub-stats">
          <div className="hub-stat"><div className="hub-stat-val">{totalPages}</div><div className="hub-stat-lbl">Expert Guides</div></div>
          <div className="hub-stat"><div className="hub-stat-val">15+</div><div className="hub-stat-lbl">FAQs per Guide</div></div>
          <div className="hub-stat"><div className="hub-stat-val">Free</div><div className="hub-stat-lbl">All Guides</div></div>
          <div className="hub-stat"><div className="hub-stat-val">Live</div><div className="hub-stat-lbl">Coaching Available</div></div>
        </div>

        {/* Pillar sections */}
        <div className="hub-body">
          {PILLARS.map(pillar => (
            <div key={pillar.id} className="hub-pillar">
              <div className="hub-pillar-header">
                <span className="hub-pillar-badge">{pillar.label}</span>
                <span className="hub-pillar-title">{pillar.title}</span>
              </div>

              <div className="hub-grid">
                {pillar.pages.map((page, i) => {
                  const ts = TYPE_STYLE[page.type] || TYPE_STYLE.Guide;
                  return (
                    <Link key={page.to} to={page.to} className={`hub-card${i === 0 ? ' is-pillar' : ''}`}>
                      <div className="hub-card-top">
                        <span className="hub-card-icon">{page.icon}</span>
                        <span className="hub-card-type" style={{ background: ts.bg, color: ts.color, borderColor: ts.border }}>
                          {page.type}
                        </span>
                      </div>
                      <div className="hub-card-title">{page.title}</div>
                      <div className="hub-card-subtitle">{page.subtitle}</div>
                      <div className="hub-card-desc">{page.desc}</div>
                      <div className="hub-card-arrow">Read guide →</div>
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CuetHubPage;
